export default "__VITE_ASSET__CPzS0Ol0__"